import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';
import { Card } from 'components/layout/profile/profileContent/styles';

export const DataContainer = styled.div`
  display: inline-flex;
  grid-gap: 10px;
  justify-content: center;
  align-content: center;
  width: 100%;
  flex-wrap: wrap;
`;

export const Disclaimer = styled.span`
  display: block;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-top: auto;
  > a {
    color: ${({ theme }) => theme.default.colors.palette.Business_DataVizLilacDark};
    text-decoration: underline;
  }
`;

export const CustomCard = styled(Card)`
  ${screenMd} {
    padding: 30px;
  }
`;
